export default "__VITE_ASSET__iUSOhEl0__"